import { render } from "./UsadosCard.vue?vue&type=template&id=51cf5d18"
import script from "./UsadosCard.vue?vue&type=script&lang=js"
export * from "./UsadosCard.vue?vue&type=script&lang=js"

import "./UsadosCard.vue?vue&type=style&index=0&id=51cf5d18&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__